class Picklist {
  constructor(placeholder) {
    this.placeholder = placeholder;
    this.picklistValues = placeholder.nextElementSibling;
    this.items = this.getItemsFromNode();
    this.savedItems = this.getItemsFromNode("saved");
    this.destinationContainer = this.placeholder.querySelector(".picklist-destination");
    this.reordering = false;
    this.sortableParams = {
      axis: "y",
      containment: "parent",
      update: () => {
        const event = new CustomEvent("listChange");
        window.dispatchEvent(event);
      },
    };
    this.output = [];
    this.fillLists();
    this.bindTransferHandler();
    this.bindReorderHandler();
    this.bindChangeListener();
  }

  static deleteInstance(target, instanceId) {
    const saved = JSON.parse(target.getAttribute("data-saved"));
    const list = JSON.parse(target.getAttribute("data-list"));
    const all_todos = list.concat(saved);
    target.setAttribute("data-list", JSON.stringify(all_todos));
    target.setAttribute("data-saved", "[]");
    target.removeAttribute("data-instance-id");
    target.querySelector(".picklist-source").innerHTML = "";
    target.querySelector(".picklist-destination").innerHTML = "";
    target.nextElementSibling.value = "[]";
    window.Picklists.forEach((element, index) => {
      if (element.id == instanceId) {
        delete element.instance;
        window.Picklists.splice(index, 1);
      }
    });
  }

  static getInstance(node) {
    if (!window.Picklists) return;
    let picklistInstance = null;
    const id = node.dataset.instanceId;
    window.Picklists.forEach((picklist) => {
      if (picklist.id === id) {
        picklistInstance = picklist.instance;
      }
    });

    return picklistInstance;
  }

  initializeSelectable(container) {
    container.querySelectorAll("li").forEach((element) => {
      element.addEventListener("click", this.selectElement);
    });
  }

  selectElement(e) {
    e.target.classList.toggle("ui-selected");
  }

  removeSelectedClass(element) {
    element.querySelectorAll("li").forEach((item) => item.classList.remove("ui-selected"));
  }

  disableSelection(element) {
    element.querySelectorAll("li").forEach((item) => {
      item.removeEventListener("click", this.selectElement);
    });
  }

  bindReorderHandler() {
    const picklistReorder = this.placeholder.querySelector(".picklist-reorder");
    if (picklistReorder) {
      picklistReorder.addEventListener("click", () => {
        this.handleReorderClick(picklistReorder);
      });
    }
  }

  handleReorderClick(button) {
    button.classList.toggle("reordering");
    if (this.reordering) {
      this.initializeSelectable(this.destinationContainer);
      this.removeSelectedClass(this.destinationContainer);
      $(this.destinationContainer).sortable("destroy");
    } else {
      $(this.destinationContainer).sortable(this.sortableParams);
      this.removeSelectedClass(this.destinationContainer);
      this.disableSelection(this.destinationContainer);
    }
    this.generateOutput();
    this.reordering = !this.reordering;
  }

  bindTransferHandler() {
    const lists = {
      destination: this.destinationContainer,
      source: this.placeholder.querySelector(".picklist-source"),
    };
    const controls = this.placeholder.querySelector(".picklist-controls");
    controls.querySelector(".left").addEventListener("click", () => {
      this.transferElement(lists.destination, lists.source);
      const event = new CustomEvent("listChange");
      window.dispatchEvent(event);
    });
    controls.querySelector(".right").addEventListener("click", () => {
      this.transferElement(lists.source, lists.destination);
      const event = new CustomEvent("listChange");
      window.dispatchEvent(event);
    });
  }

  transferElement(source, destination) {
    const items = source.querySelectorAll(".ui-selected");
    items.forEach((item) => {
      item.classList.remove("ui-selected");
    });
    const fragment = document.createDocumentFragment();
    items.forEach((item) => fragment.appendChild(item));
    destination.appendChild(fragment);
  }

  getItemsFromNode(list = "list") {
    let dataAttr = this.placeholder.getAttribute(`data-${list}`);
    if (list === "saved") {
      dataAttr = JSON.parse(dataAttr).map((listItem) => (listItem = listItem));

      return dataAttr;
    }
    return JSON.parse(dataAttr);
  }

  fieldNameParser() {
    return {
      parse: (listItem) => listItem[0].split("_").join(" "),
      stringify: (listItem) => listItem.toLowerCase().split(" ").join("_"),
      getId: (listItem) => listItem[1],
    };
  }

  fillLists() {
    this.items.forEach((listItem) => {
      if (this.savedItems.includes(listItem)) return;
      const listItemLabel = this.fieldNameParser().parse(listItem);
      const listItemId = this.fieldNameParser().getId(listItem);
      this.placeholder
        .querySelector(".picklist-source")
        .insertAdjacentHTML("beforeend", `<li id="${listItemId}">${listItemLabel}</li>`);
    });
    this.savedItems.forEach((listItem) => {
      const listItemLabel = this.fieldNameParser().parse(listItem);
      const listItemId = this.fieldNameParser().getId(listItem);
      this.placeholder
        .querySelector(".picklist-destination")
        .insertAdjacentHTML("beforeend", `<li id="${listItemId}">${listItemLabel}</li>`);
    });
    this.picklistValues.value = JSON.stringify(this.generateOutput(this.savedItems));
    this.initializeSelectable(this.destinationContainer);
    const picklistSource = this.placeholder.querySelector(".picklist-source");
    this.initializeSelectable(picklistSource);
  }

  generateOutput() {
    const result = [];
    this.destinationContainer.querySelectorAll("li").forEach((child, index) => {
      result.push(child.id);
    });

    return result;
  }

  bindChangeListener() {
    window.addEventListener("listChange", () => {
      this.output = this.generateOutput();
      this.picklistValues.value = JSON.stringify(this.output);
    });
  }
}

export default Picklist;
